import Cookie from 'js-cookie';
import api from "@/api/common/index.js";
import * as dd from 'dingtalk-jsapi'
import Url from 'url';

export function getCookie(name) {
    var strcookie = document.cookie
    var arrcookie = strcookie.split('; ')

    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=')
        if (arr[0] == name) {
            return arr[1]
        }
    }
    return ''
}

export function getToken() {
    var token = getCookie('_token'),
        pattern = /{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/,
        tokens = pattern.exec(decodeURIComponent(token))

    token = tokens ? tokens[1] : ''
    return token
}

export const delCookie = (name, domain, path = "/") => {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    let cval = getCookie(name)
    if (cval != null && !domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}`
    else if (cval != null && domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}; domain=${domain}`
}

export function getQueryParamByKey(paramName) {
    var url = document.location.toString()
        // 如果url中有特殊字符则需要进行一下解码
    url = decodeURI(url)
    var arrObj = url.split("?");
    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");
            if (arr != null && arr[0] == paramName) {
                return decodeURIComponent(arr[1]);
            }
        }
        return "";
    } else {
        return "";
    }
}

export function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var r = window.location.href.slice(window.location.href.indexOf('?' + name)).substr(1).match(reg)
    if (r != null) return decodeURI(r[2])
    return null
}

export const getIframeLink = (link, code) => {
    let result;
    if (link.includes('callback') && link.length > 0) {
        api.getRealLink({ 'callback': encodeURIComponent(link.slice(link.indexOf('callback') + 9)) }).then(res => {
            res.code == 10000 && res.data.load_url.length > 0 ?
                result = res.data.load_url : result = '';
        }).catch(err => console.error(err))
    } else {
        result = findLinkStr(link, code);
    }
    return result
}

export function findLinkStr(link, code) {
    let menu_code = Boolean(code) ? ('&menu_code=' + code) : '';
    if (link.includes('admin')) {
        return link + '&tenant=' + localStorage.getItem('tenant_id') + menu_code;
    }
    if (link.includes('yumi-tool')) {
        return link;
    }

    // 对没有返回按钮的内页加参数
    return link.length > 0 ?
      link.includes('?') ? ( link + '&' + String(Math.random() * 1000).slice(0, 3) + menu_code ) : ( link + '?' + String(Math.random() * 1000).slice(0, 3) + menu_code ) :
        '';
}

export function getLink(item, index) {
    if (item == undefined || item.length == 0) return ['', 0, ''];
    if (item.children.length == 0 && item.hasOwnProperty('menu_type')) {
        return item.menu_type == 'link' ? [getIframeLink(item.link, item.menu_code), index + 1, item] : ['', index + 1, item];
    }
    return getLink(item.children[0], index + 1);
}

export function findAll(item, aim, level, index) {
    let res = '';

    function findIndex(item, aim, level, index) {
        let num = item.length;
        for (let i = 0; i < num; i++) {
            if (res !== '') {
                break;
            } else if (item[i].menu_code == aim) {
                res = level <= 1 ? `${i}` : `${index}.${i}`;
                return res;
            } else if (item[i].hasOwnProperty('children') && item[i].children.length > 0) {
                findIndex(item[i].children, aim, level + 1, i)
            }
        }
        if (res !== '') return res;
        return
    }
    return findIndex(item, aim, level, index)
}

export function findMenuLocation(cacheIndex, arr) {
    let levels;
    if (cacheIndex == undefined || cacheIndex == null) return '';
    cacheIndex.includes('.') ? levels = cacheIndex.split('.') : levels = [cacheIndex];
    if (levels.length == 1) {
        return arr[levels[0]];
    } else {
        return arr[levels[0]].children[levels[1]]
    }
}

export function getStorage(name) {
    return JSON.parse(localStorage.getItem(name))
}

export function setStorage(name, data) {
    return localStorage.setItem(name, JSON.stringify(data));
}

export function filterNum(string) {
    string = String(string);
    // return string.replace(/[^0-9]/ig,"")
    // return string.replace(/[^\-?\d.]/g,'')
    // let str = string.includes('.')? Number(string.match(/\d+\.\d+/g)[0]).toFixed(2) : string.replace(/[^0-9]/ig,"");
    let str = string.includes('.') ? Number(string.match(/^[+-]?\d+(\.\d+)?/g)[0]).toFixed(2) : string.match(/^[+-]?\d+/g)[0];
    return str;
}

export function roundingNum(str) {
    let rate = filterNum(str);
    if (String(rate).includes(".")) {
        let integer = Math.trunc(rate);
        let decimal = Number(rate) - Math.trunc(rate);
        decimal < 0.5 ?
            '' : integer += 1;
        return integer;
    } else {
        return Math.trunc(rate);
    }
}

export function fileSize(val) {
    var returnData = 0;
    if (!val) {
        return '0';
    }
    if (val > 0) {
        if (val > 1024 * 1024 * 1024) {
            let G = val / (1024 * 1024 * 1024);
            // G = this.fomatFloat(G,2);
            G = Math.round(G * Math.pow(10, 2)) / Math.pow(10, 2);
            returnData = G + 'G';
        } else if (val > 1024 * 1024) {
            let M = val / (1024 * 1024);
            // M = this.fomatFloat(M,2);
            M = Math.round(M * Math.pow(10, 2)) / Math.pow(10, 2);
            returnData = M + 'M';
        } else if (val > 1024) {
            let K = val / (1024);
            // K = this.fomatFloat(K,2);
            K = Math.round(K * Math.pow(10, 2)) / Math.pow(10, 2);
            returnData = K + 'K';
        } else {
            returnData = val + 'B';
        }
    }
    return returnData;
}

export function fileSizeCompute(size, unit) {
    // 全部转化为KB进行计算
    if (unit.toLowerCase() == 'yb') {
        return size * Math.pow(1024, 7)
    } else if (unit.toLowerCase() == 'zb') {
        return size * Math.pow(1024, 6)
    } else if (unit.toLowerCase() == 'eb') {
        return size * Math.pow(1024, 5)
    } else if (unit.toLowerCase() == 'pb') {
        return size * Math.pow(1024, 4)
    } else if (unit.toLowerCase() == 'tb') {
        return size * Math.pow(1024, 3)
    } else if (unit.toLowerCase() == 'gb') {
        return size * Math.pow(1024, 2)
    } else if (unit.toLowerCase() == 'mb') {
        return size * Math.pow(1024, 1)
    } else if (unit.toLowerCase() == 'kb') {
        return size
    }
}

export const localUrl = (tenant) => {
    let index = window.CONFIG.EducationHome.indexOf('#')
    let url = window.CONFIG.EducationHome
    let before = url.slice(0, index);
    let after = url.slice(index);
    tenant == undefined || tenant == null ? (tenant = getStorage('tenant_id')) : '';
    return before + "?tenant_code=" + tenant + '#/home';
}

export const addTenant = (tenant) => {
    let url = location.href;
    if (url.includes('?tenant_code') == false) {
        let index = url.indexOf('#');
        let past = url.slice(0, index)
        let after = url.slice(index);
        location.href = past + "?tenant_code=" + tenant + after;
    }
}

export const setGroupUser = async(url) => {
    await api.getGroupUser().then(async res => {
        console.log(res);
        if (res.code == 10000) {
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            await setUser(url);
        } else {
            signinRedirect(url, 'cmc')
        }
    }).catch(err => {
        console.error(err);
    })
}

export const setUser = async(url) => {
    // 判断栖学用户信息是否过期
    await api.getUserInfo({}).then(async res => {
        if (res.hasOwnProperty('params')) {
            const yjUserInfo = res.params
            localStorage.setItem('yjUserInfo', JSON.stringify(yjUserInfo));
            localStorage.setItem('tenant_id', yjUserInfo.tenant_id);
            if (dd.env.platform == 'notInDingTalk') {
                addTenant(yjUserInfo.tenant_id);
            }
            let userInfoStr = localStorage.getItem('userInfo');
            if (userInfoStr) {
                let userInfo = JSON.parse(userInfoStr);
                let groProduct_id = userInfo.product_info && userInfo.product_info.product_id;
                let product_id = yjUserInfo.tenant && yjUserInfo.tenant.data && yjUserInfo.tenant.data.cmcGroup && yjUserInfo.tenant.data.cmcGroup.productId;
                if (groProduct_id !== product_id) {
                    await api.updateProductId({product_id: product_id}).then(res => {
                        if (res.code === 10000) {
                            console.log('产品id与框架不一致')
                            location.reload();
                        }
                    }).catch(error => {
                        console.error(error);
                    })
                }
            }
        } else {
            signinRedirect(url)
        }
    }).catch(err => { console.log(err); })

    // 获取标题、图片
    await api.getTitle({ tenant_code: getStorage('tenant_id') }).then(res => {
        if (res.success) {
            setStorage('logoInfo', res.data)
            if (res.data.page_logo) {
                var link = document.createElement('link');
                link.rel = 'shortcut icon'; 
                link.href = res.data.page_logo; // 设置自定义favicon图片的URL地址
                document.head.appendChild(link)
            }
        }
    }).catch(err => {
        console.log(err)
    })
}

//获取用户信息
export const checkUserInfoPro = async() => {
    let url = location.href;
    if (getToken().length > 0) {
        // 判断框架用户信息是否过期
        // await api.getGroupUser().then(async res => {
        //   console.log(res);
        //   if(res.code == 10000) {
        //     localStorage.setItem("userInfo", JSON.stringify(res.data));
        //   }else {
        //     signinRedirect(url)
        //   }
        // }).catch(err => {
        //   console.error(err);
        // })
        await setGroupUser(url);

    } else {
        signinRedirect(url, 'cmc')
            // await setGroupUser(url);
    }
}

//获取用户信息
export const checkUserInfo = async() => {
    let url = location.href;
    if (getToken().length > 0) {
        // 判断框架用户信息是否过期
        // await api.getGroupUser().then(async res => {
        //   console.log(res);
        //   if(res.code == 10000) {
        //     localStorage.setItem("userInfo", JSON.stringify(res.data));
        //   }else {
        //     signinRedirect(url)
        //   }
        // }).catch(err => {
        //   console.error(err);
        // })
        await setGroupUser(url);

    } else {
        signinRedirect(url)
            // await setGroupUser(url);
    }
}

export const checkLoginStatus = () => {
    if (getToken().length > 0) {} else {
        signinRedirect(location.href)
    }
}

export const signinRedirect = (url, cmcType) => {
    // location.href = `${window.CONFIG.webLoginUrl}?forward=${encodeURIComponent(url)}&tenant_code=${tenantId}`
    document.cookie = '';
    delCookie('_token', window.location.host)
    localStorage.clear();
    let query = Url.parse(url, true).query
    console.log('重定向检测', url, query)
    let tenant_code = query ? query.tenant_code : null;
    let forward = encodeURIComponent(url);
    let loginUrl = '';
    if (cmcType) {
        loginUrl = window.CONFIG.CASAPI + `/index.php?r=auth/login&auType=cmc&forward=` + forward;
    } else {
        loginUrl = window.CONFIG.CASAPI + `/index.php?r=auth/login&auType=${window.CONFIG.CASAUTYPE}&forward=` + forward;
    }
    if (tenant_code) {
        loginUrl += "&tenant_code=" + tenant_code;
    }
    // 没有token 走钉钉
    // alert(dd.env.platform);
    // alert(getToken());
    if (dd.env.platform != 'notInDingTalk' && getToken() == '') {
        ddSign(url)
    } else {
        location.href = loginUrl
    }
}

export const ddSign = async(url) => {
    //1.获取租户code
    let query = Url.parse(url, true).query
    let tenant_code = query ? query.tenant_code : null;
    console.log('tenant_code', tenant_code);
    //2.获取dingcode
    let id = await getDingCordId(tenant_code);
    // alert(id);
    //3.登录跳转
    dd.ready(() => {
        dd.runtime.permission.requestAuthCode({
            corpId: id,
            onSuccess: (info) => {
                const code = info.code
                const params = {
                    r: 'auth/login',
                    auType: 'dingtalk',
                    tenant_code: tenant_code,
                    code,
                    forward: encodeURIComponent(url)
                }
                const paramsStr = Object.keys(params).reduce((total, value, index) => {
                    if (index == 0) return `${total}?${value}=${params[value]}`
                    else return `${total}&${value}=${params[value]}`
                }, '')
                console.log(`${window.CONFIG.DdLogin}${paramsStr}`, 'dd地址');
                location.href = `${window.CONFIG.DdLogin}${paramsStr}`
            },
            onFail: () => {
                console.log('faile')
                return
                // 解析失败走泛域名解析进行登陆
                let forward = encodeURIComponent(url);
                let loginUrl = window.CONFIG.CASAPI + "/index.php?r=auth/login&auType=cmc&forward=" + forward;
                if (tenant_code) {
                    loginUrl += "&tenant_code=" + tenant_code;
                }
                location.href = loginUrl
            }
        })
    })
}

export const getDingCordId = async(id) => {
    return await api.getDingCordId(id).then(response => {
        if (response.params && response.params.list && response.params.list[0]) {
            return response.params.list[0].app_conf.CorpId;
        } else {
            return '';
        }
    }).catch(error => {
        console.error(error);
    })
}

export const logout = () => {
    let tenant_code = localStorage.getItem('tenant_id')
    delCookie('_token', window.location.host)
    document.cookie =
        'iPlanetDirectoryPro=""; expires=' +
        new Date(1970, 0, 1).toUTCString() +
        "; domain=" +
        window.CONFIG.DOMAIN;
    localStorage.clear();
    if (tenant_code) {
        location.href = window.CONFIG.CASAPI + `/index.php?r=auth/cmc-loginout&auType=${window.CONFIG.CASAUTYPE}&tenant_code=${tenant_code}&forward=${encodeURIComponent(window.location.href)}`
    } else {
        location.href = window.CONFIG.CASAPI + `/index.php?r=auth/cmc-loginout&auType=${window.CONFIG.CASAUTYPE}&forward=${encodeURIComponent(window.location.href)}`
    }
}

export const sleep = (time) => {
    return new Promise(function(resolve) {
        setTimeout(resolve, time);
    })
}

export const throttle = (callBack, intervalTime) => {
    var time = 0; // 时间变量
    return function() {
        var context = this;
        var curTime = +new Date(); // 当前执行的时间
        // 当前执行时间距离上次执行的时间是否大于等于间隔时间
        if (curTime - time >= intervalTime) {
            time = curTime;
            callBack.apply(context, arguments)
        }
    }

}


export function hash(str) { // 上传文件的hash
  let hash = 0, i, char, l;
  if (str.length == 0) return hash;
  for (i = 0, l = str.length; i < l; i++) {
    char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}



// WEBPACK FOOTER //
// ./src/utils/index.js